import { Children, isValidElement } from 'react';
import { Flex, FlexProps } from '../../../atoms';
import { OutletHeaderBackButton } from './components/outlet-back-button';
import { OutletFooter } from './components/outlet-footer';
import { OutletHeader } from './components/outlet-header';
import { OutletHeaderExtra } from './components/outlet-header-extra';
import { OutletHeaderHeading } from './components/outlet-heading';
import { OutletMain } from './components/outlet-main';
import { OutletScrollable } from './components/outlet-scrollable';

export function BasicOutlet({ children, ...rest }: FlexProps): JSX.Element {
  let scrollable: JSX.Element | null = null;
  let footer: JSX.Element | null = null;

  Children.forEach(children, (child) => {
    if (!isValidElement(child)) {
      return;
    }
    if (child.type === OutletScrollable) {
      scrollable = child;
    }
    if (child.type === OutletFooter) {
      footer = child;
    }
  });
  return (
    <Flex
      w="100%"
      h="100dvh"
      sx={{
        '@supports not (height: 100dvh)': {
          height: '100%'
        }
      }}
      flexDir="column"
      overflow="hidden"
      {...rest}
    >
      {scrollable && scrollable}
      {footer && footer}
    </Flex>
  );
}

BasicOutlet.Scrollable = OutletScrollable;
BasicOutlet.Footer = OutletFooter;
BasicOutlet.Header = OutletHeader;
BasicOutlet.Heading = OutletHeaderHeading;
BasicOutlet.Main = OutletMain;
BasicOutlet.BackButton = OutletHeaderBackButton;
BasicOutlet.HeaderExtra = OutletHeaderExtra;
